import SearchBar from "components/BaseWidgets/search";
import "./style.scss";
import StoryCard from "components/Cards/storyCard";
import { useSuccessStories } from "hooks/api/useHome";
import Skeleton from "components/BaseWidgets/skeleton";
import EmptyState from "components/BaseWidgets/emptyState";
import { useState } from "react";

function SuccessStories() {
  const [searchKey, setSearchKey] = useState("");

  const handleSearch = (value) => {
    setSearchKey(value);
  };

  const { data: stories, isLoading: isStoriesLoading } = useSuccessStories({
    see_all: true,
    search_key: searchKey,
  });

  const successStories = stories || [];

  return (
    <div className="success-story-wrapper container">
      <h1 className="pb-1 font-title-xxl">Success stories</h1>
      <p className="font-title-normal fw-500">
        Read couples' genuine love stories, inspiring love journeys
      </p>
      <div className="search-wrap">
        <SearchBar onSearch={handleSearch} value={searchKey} />
      </div>
      {isStoriesLoading ? (
        <Skeleton height={200} count={6} label={false} width="100%" />
      ) : successStories.length === 0 ? (
        <EmptyState
          message={"No data blogs found!"}
          className="overview-empty"
        />
      ) : (
        <div className="story-grid">
          {successStories.map((item) => (
            <StoryCard
              key={item?.id}
              id={item?.id}
              image={item?.images?.[0]?.image}
              title={`${item?.user?.first_name || ""} & ${item?.partner?.first_name || ""}`}
              description={item?.body}
              date={item?.created_at ? item.created_at.split("T")[0] : ""}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default SuccessStories;
